import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { CircularProgress } from '@mui/material';
export function LoadingScreen(props) {
    const textDiv = props.text ? (_jsx("div", { style: {
            padding: '15px',
        }, children: props.text })) : (_jsx(_Fragment, {}));
    const spinnerDiv = (_jsx("div", { style: {
            padding: '15px',
            textAlign: 'center',
        }, children: _jsx("div", { style: {
                display: 'inline-block',
            }, children: _jsx(CircularProgress, { color: "primary" }) }) }));
    return (_jsxs("div", { style: {
            flex: 1,
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
        }, children: [textDiv, spinnerDiv] }));
}
//# sourceMappingURL=LoadingScreen.js.map